<form
  [formGroup]="addTargetForm"
  (ngSubmit)="onSubmit()"
  [class.disabled]="isLoading()"
  id="addTargetForm"
>
  <h2 class="form-title">{{ titleName }}</h2>

  <div class="control-row" *ngIf="!hideSessionSelector && !creatingSession()">
    <div class="control no-margin">
      <label for="target">Session:</label>
      <p-dropdown
        id="sessionDropdown"
        filter="true"
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="sessions()"
        [(ngModel)]="selectedSession"
        [ngModelOptions]="{standalone: true}"
        optionLabel="label"
        [loading]="isLoading()"
        (onChange)="changedSession($event)"
      >
      <ng-template pTemplate="selectedSession" let-selectedOption>
        <div class="flex align-items-center gap-2">
          <div>
            <small> {{ selectedSessionLabel(selectedOption.value) }}</small><br>
            {{ this.formattedDates(selectedOption.value.StartedDate, selectedOption.value.FinishedDate) }}
           
          </div>
        </div>
      </ng-template>
      </p-dropdown>
      <small>If the session was still not created, you can create it by clicking <a href="javascript:void(0)" (click)="showCreateSession()">here</a>.</small>
    </div>
  </div>

  <div class="control-row" *ngIf="creatingSession()">
    <div class="control no-margin">
      <label for="target">Create New Session:</label>
      <div>
        <div >
          <label for="startDate">New Session Start Date</label>
          <input 
            id="startDate"
            type="datetime-local" 
            pInputText 
            [(ngModel)]="newSessionStartDate" 
            [ngModelOptions]="{standalone: true}"
          />
        </div>
        <div >
          <label for="endDate">New Session End Date</label>
          <input 
            id="endDate"
            type="datetime-local" 
            pInputText 
            [(ngModel)]="newSessionEndDate" 
            [ngModelOptions]="{standalone: true}"
          />
        </div>
      </div>
      <small><a href="javascript:void(0)" (click)="hideCreateSession()">Back to select session</a></small>
    </div>
  </div>

  <div class="control-row" *ngIf="!hideTargetSelector">
    <div class="control no-margin">
      <label for="target">Target:</label>
      <p-dropdown
        id="targetDropdown"
        filter="true"
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="targets()"
        formControlName="target"
        optionLabel="label"
        [loading]="isLoading()"
        (onChange)="changedTarget($event)"
      >
      </p-dropdown>
      @if(addTargetForm.controls.target.invalid &&
      addTargetForm.controls.target.touched) {
      <span class="control-error">Target is required.</span>
      }
    </div>
  </div>

  <div class="control-row" *ngIf="shouldShowStaffSelector()">
    <div class="control no-margin">
      <label for="selectedStaff">Staff:</label>
      <p-dropdown
        id="selectedStaffDropdown"
        filter="true"
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="staffOptions()"
        formControlName="selectedStaff"
        optionLabel="label"
        [loading]="isLoading()"
        [disabled]="!selectedSession"
      >
      </p-dropdown>
    </div>
  </div>

  <div class="control-row">
    <div class="control no-margin">
      <label for="recordedDate">{{ targetIsFrequency() ? 'Start Date/Time' : 'Recorded Date' }}</label>
      <input
        type="datetime-local"
        [style]="{ width: '100%' }"
        appendTo="body"
        class="form-control"
        name="recordedDate"
        formControlName="recordedDate"
        autocomplete="off"
      />
    </div>
  </div>

  @if (targetIsFrequency()) {
    <div class="control-row">
      <div class="control no-margin">
        <label for="frequencyOccurrences">Occurrences:</label>
        <p-inputNumber
          inputId="frequencyOccurrences"
          formControlName="frequencyOccurrences"
          [style]="{ width: '100%' }"
          [showButtons]="true"
          [min]="1"
          [max]="maxBulkFrequencyOccurrences"
          [step]="1"
          [maxFractionDigits]="0"
        />
        @if (addTargetForm.controls.frequencyOccurrences.invalid &&
          addTargetForm.controls.frequencyOccurrences.touched) {
          <span class="control-error">
            Occurrences must be a whole number from 1 to {{ maxBulkFrequencyOccurrences }}.
          </span>
        }
      </div>
    </div>

    @if (showFrequencyEndDate()) {
      <div class="control-row">
        <div class="control no-margin">
          <label for="frequencyEndDate">End Date/Time</label>
          <input
            id="frequencyEndDate"
            type="datetime-local"
            [style]="{ width: '100%' }"
            class="form-control"
            formControlName="frequencyEndDate"
            autocomplete="off"
          />
          @if (addTargetForm.controls.frequencyEndDate.invalid &&
            addTargetForm.controls.frequencyEndDate.touched) {
            <span class="control-error">
              End date/time is required when adding more than one occurrence.
            </span>
          }
        </div>
      </div>
    }
  }

  

  @if(selectedTarget() && !targetIsFrequency()) {
  <div class="control-row">
    <div class="control no-margin">
        @if (targetIsDuration() || targetIsToileting()) {
            <label for="duration">Duration (in minutes): </label>
        } @else {
            <label for="value">Value:</label>
        }
      @if (targetIsPromptBased()) {
            @if (targetIsEchoic()) {
                <p-dropdown
                    class="pe-1"
                    [options]="promptOptionsForTarget()"
                    formControlName="selectedPromptCode"
                    [checkmark]="true"
                    optionLabel="text"
                    optionValue="value"
                    [style]="{ width: '100%' }"
                    [appendTo]="'body'"
                    placeholder="Select a prompt code"
                />
                <p-dropdown
                [options]="extraOptionsForEchoicTarget()"
                formControlName="selectedEchoicRate"
                [checkmark]="true"
                optionLabel="text"
                optionValue="value"
                [style]="{ width: '100%' }"
                [appendTo]="'body'"
                placeholder="Select an echoic rate"
                />
            } @else {
            <p-dropdown
            [options]="promptOptionsForTarget()"
            formControlName="selectedPromptCode"
            [checkmark]="true"
            optionLabel="text"
            optionValue="value"
            [style]="{ width: '100%' }"
            [appendTo]="'body'"
            />
            } 
        } @else if (targetIsIntValueOnly()) {
            <input
            pInputText
            type="number"
            formControlName="textValue"
            [style]="{ width: '100%' }"
            placeholder="Enter a value"
            />
        } @else if (targetIsIntensity()) {
            <p-selectButton
              formControlName="intensityValue"
              [options]="targetIntensityOptions()"
              optionLabel="label"
              optionValue="value"
            />
        } @else if (targetIsDuration() || targetIsToileting()) {
            <p-inputNumber
            autoWidth="false"
            [style]="{ width: '100%' }"
            formControlName="duration"
            [showButtons]="true"
            [minFractionDigits]="1"
            [maxFractionDigits]="2"
            />
        } @else if (targetIsWholePartialInterval()) {
            <p-checkbox
            [binary]="true"
            formControlName="happened"
            label="Happened"
            styleClass="app-checkbox"
            />
        } @else if (targetIsFluencyRate()) {
          <div class="flex gap-2">
            <label for="correctCount">Correct Count:</label>
              <p-inputNumber
                  formControlName="correctCount"
                  [showButtons]="true" 
                  placeholder="Correct Count"
              />
            <label for="incorrectCount">Incorrect Count:</label>
                <p-inputNumber
                    formControlName="incorrectCount" 
                    [showButtons]="true"
                    placeholder="Incorrect Count"
                />
          </div>
        }@else {
            <input
            pInputText
            type="text"
            formControlName="textValue"
            [style]="{ width: '100%' }"
            placeholder="Enter a value"
            />
        }
    </div>
  </div>
  }

  @if (targetIsToileting()) {
    <div class="control-row">
      <div class="control no-margin">
        <label for="toileting">Toileting:</label>
      <div class="toileting-checkboxes" style="display: flex; justify-content: space-between; gap: 1rem;">
        <span>
          <p-checkbox
            inputId="add-target-data-toileting-urination-on"
            [binary]="true"
            [ngModel]="urinationOn()"
            (ngModelChange)="urinationOn.set($event)"
            [ngModelOptions]="{standalone: true}"
            styleClass="app-checkbox">
          </p-checkbox>
          <label for="add-target-data-toileting-urination-on" class="ml-2">Urination On</label>
        </span>

        <span>
          <p-checkbox
            inputId="add-target-data-toileting-urination-off"
            [binary]="true"
            [ngModel]="urinationOff()"
            (ngModelChange)="urinationOff.set($event)"
            [ngModelOptions]="{standalone: true}"
            styleClass="app-checkbox">
          </p-checkbox>
          <label for="add-target-data-toileting-urination-off" class="ml-2">Urination Off</label>
        </span>

        <span>
          <p-checkbox
            inputId="add-target-data-toileting-bowel-on"
            [binary]="true"
            [ngModel]="bowelMovementOn()"
            (ngModelChange)="bowelMovementOn.set($event)"
            [ngModelOptions]="{standalone: true}"
            styleClass="app-checkbox">
          </p-checkbox>
          <label for="add-target-data-toileting-bowel-on" class="ml-2">Bowel Movement On</label>
        </span>

        <span>
          <p-checkbox
            inputId="add-target-data-toileting-bowel-off"
            [binary]="true"
            [ngModel]="bowelMovementOff()"
            (ngModelChange)="bowelMovementOff.set($event)"
            [ngModelOptions]="{standalone: true}"
            styleClass="app-checkbox">
          </p-checkbox>
          <label for="add-target-data-toileting-bowel-off" class="ml-2">Bowel Movement Off</label>
        </span>

        <span>
          <p-checkbox
            inputId="add-target-data-toileting-no-void"
            [binary]="true"
            [ngModel]="noVoid()"
            (ngModelChange)="noVoid.set($event)"
            [ngModelOptions]="{standalone: true}"
            styleClass="app-checkbox">
          </p-checkbox>
          <label for="add-target-data-toileting-no-void" class="ml-2">No Void</label>
        </span>
      </div>
      </div>
    </div>
  }

  @if (isLoading()) {
  <div class="loading">
    <app-loading-indicator />
  </div>
  }

  <p class="actions" style="position: sticky; bottom: 0" id="addTargetButtons">
    <button
      type="button"
      class="switch-mode-button"
      style="margin-right: auto; cursor: pointer;"
      (click)="onCancel()"
      [disabled]="isLoading()"
    >
      Cancel
    </button>
    <button
      type="submit"
      id="saveTargetButton"
      class="side-menu-button2"
      style="cursor: pointer;"
      [disabled]="isLoading()"
    >
      {{ actionName }}
    </button>
  </p>
</form>
